module.exports = __webpack_public_path__ + "img/circle-info.6b9a11bf.svg";